import { getOrderedContentElements } from '../../common/contact-info/publish';

const ContactInfo = props => getOrderedContentElements(props, true);
export default ContactInfo;
